import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import { ReactComponent as Warning } from 'assets/icons/ExclamationCircleIcon.svg';

import { AlertComponent } from 'components/_basic/AlertComponent';
import { IEnterConfirmCodeWarning } from 'components/Registration/types';

import styles from './EnterConfirmCodeWarning.module.scss';

export const EnterConfirmCodeWarning = ({ nextStepHandler }: IEnterConfirmCodeWarning) => {
  const { t } = useTranslation();
  
  return (
    <AlertComponent
      severity="error"
      message={
        <Typography variant="subtitle2" display="inline" className="alert">
          {t('notConfirmedEmail')}
          <Typography variant="subtitle2" display="inline" className={styles.nextStepText} onClick={nextStepHandler}>
            {t('enterTheCode')}
          </Typography>
        </Typography>
      }
      className={styles.alert}
      icon={<Warning className={styles.icon} />}
    />
  );
};
